import Api from './api';

const slug = 'v1/courses';
export default {
  createCourse(course) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/`, course)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getCourses(includeDrafts = false) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, {
        params: {
          includeDrafts,
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getCourse(courseSlug) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${courseSlug}`, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateCourse(course) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/update/${course._id}`, course)
        .then(res => resolve(res.data[0]))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteCourse(course) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${course._id}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getUserCourses(params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, {
        params,
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  addMemberToCourse(courseId, userId) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/${courseId}/users`, {
        userId,
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  removeMemberFromCourse(courseId, userId) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${courseId}/users/${userId}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
